import api from './interceptor';

const BASE_URL_V2 = 'api/v2/classification-diseases';

export default {
  // API Version 2
  getIcdOptions: (params) => api.get(`${BASE_URL_V2}`, { params }),
};
